import { render, staticRenderFns } from "./InvoicePDFGenerator.vue?vue&type=template&id=3679fa7e&scoped=true"
import script from "./InvoicePDFGenerator.vue?vue&type=script&lang=js"
export * from "./InvoicePDFGenerator.vue?vue&type=script&lang=js"
import style0 from "./InvoicePDFGenerator.vue?vue&type=style&index=0&id=3679fa7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679fa7e",
  null
  
)

export default component.exports